import Header from './components/Header';
import Hero from './components/Hero';
import FirstViewCopy from './components/FirstViewCopy';
import NaturalFeeling from './components/NaturalFeeling';
import WhyDifficult from './components/WhyDifficult';
import WhatWeDo from './components/WhatWeDo';
import SupportDetails from './components/SupportDetails';
import Consultant from './components/Consultant';
import FAQ from './components/FAQ';
import SimpleProcess from './components/SimpleProcess';
import Footer from './components/Footer';
import FloatingButtons from './components/FloatingButtons';
import { SEO } from '../../utils/seo';

export default function HomePage() {
  const schema = {
    "@context": "https://schema.org",
    "@type": "ProfessionalService",
    "name": "おうちの相談室",
    "description": "家づくりや住まい選びで迷っている方のための相談サービス。ハウスメーカー選び、土地選び、住宅ローンなど、納得して決めるためのサポートを提供します。",
    "url": `${import.meta.env.VITE_SITE_URL || 'https://example.com'}/`,
    "address": {
      "@type": "PostalAddress",
      "streetAddress": "赤坂4-7-6",
      "addressLocality": "港区",
      "addressRegion": "東京都",
      "addressCountry": "JP"
    },
    "geo": {
      "@type": "GeoCoordinates",
      "latitude": "35.6762",
      "longitude": "139.7381"
    },
    "areaServed": {
      "@type": "Country",
      "name": "日本"
    },
    "serviceType": [
      "住宅購入・建築の方向性設計",
      "ハウスメーカー・工務店選定支援",
      "土地・不動産の見極めサポート",
      "住宅ローン・資金計画コンサルティング",
      "契約前の意思決定チェック"
    ]
  };

  return (
    <div className="min-h-screen bg-white">
      <SEO schema={schema} />
      <Header />
      <Hero />
      <FirstViewCopy />
      <NaturalFeeling />
      <WhyDifficult />
      <WhatWeDo />
      <SupportDetails />
      <Consultant />
      <FAQ />
      <SimpleProcess />
      <Footer />
      <FloatingButtons />
    </div>
  );
}